import { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import { actions } from '../../../slice';

import { saveActivityAccessesCsv } from './downloadUtils';
import { getActivityAccessFilters } from './utils';

interface Params {
  resourceArn?: string | String;
  resourceName?: string | String;
  dateRange?: { from?: Date; to?: Date };
  objectPaths?: Array<{ value: string }>;
}

// Download the activity graph accesses as CSV through the audittrail
// activity-accesses:download API. Moved out of CloudEventsActivityDrawer so
// the request and file naming can be tested on their own.
export const useActivityGraphDownload = ({
  resourceArn,
  resourceName,
  dateRange,
  objectPaths,
}: Params) => {
  const dispatch = useDispatch();

  return useCallback(() => {
    if (!resourceArn) return;

    dispatch(
      actions.downloadActivityAccesses({
        q: {
          body: getActivityAccessFilters(dateRange, resourceArn, objectPaths),
        },
        // Name the CSV after the selected resource, like other exports.
        onSuccess: res => saveActivityAccessesCsv(res, resourceName),
      }),
    );
  }, [dateRange, dispatch, objectPaths, resourceArn, resourceName]);
};
